import React from 'react';
import {
  Wrapper,
  Box,
  StyledLink,
  StyledImg,
  BoxImg,
} from 'views/Quiz/IE11Redirect/IE11Redirect.css.js';
import ButtonNext from 'components/atoms/ButtonNext/ButtonNext';
import Switcher from 'assets/img/Quiz/404/switcher-question.png';
import { useTranslation } from 'react-i18next';

const IE11Redirect = ({ language }) => {
  const { t } = useTranslation();
  return (
    <Wrapper>
      <BoxImg>
        <StyledImg src={Switcher} />
      </BoxImg>
      <Box>
        {t('IE11')}
        <StyledLink href={`microsoft-edge:http://pl.diabetino.diet/${language}/`}>
          <ButtonNext customFsDesk="24px" customPaddingDesk="24px" customWidthDesk="1000px">
            {t('IE11_Link')}
          </ButtonNext>
        </StyledLink>
      </Box>
    </Wrapper>
  );
};
export default IE11Redirect;
